@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.modalContent {
    margin: 40px;
}

.resultGrid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: 1fr;
    gap: 1em;
    margin-top: 2em;
    margin-bottom: 2em;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: repeat(1, 1fr);
    }
}
